class PageProduct {
    constructor() {
        this.productInner = document.querySelector('.js-product-inner');
        this.sliderContainer = document.querySelector('.js-product-slider');
        this.imgContainer = document.querySelector('.js-product-img');
        this.smController = new ScrollMagic.Controller();

        this.bindBtnMore();
        this.initSlider();
        this.pinSlider();
        this.pinBar();
    }

    /**
     * Разворачиваем информацию
     */
    bindBtnMore() {
        document.querySelectorAll('.js-product-more').forEach(btn => {
            btn.addEventListener('click', () => {
                let currentText = btn.classList.contains('_is-open') ? btn.getAttribute('data-text') : btn.getAttribute('data-replace');

                btn.classList.toggle('_is-open');
                btn.innerHTML = currentText;

                //document.querySelector('.js-product-text').classList.add('_is-open');
                document.querySelector('.js-product-text').classList.toggle('_is-open');
                this.updateState();
            });
        });
    }

    /**
     * Слайдер изображений
     */
    initSlider() {
        if (!this.sliderContainer) return;

        this.swiper = new Swiper(this.sliderContainer.querySelector('.js-product-swiper'), {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 10,
            threshold: 10,
            roundLengths: true,
            speed: 500,
            watchOverflow: true,
            watchSlidesVisibility: true,
            a11y: true,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true
            },
            pagination: {
                el: this.sliderContainer.querySelector('.js-pagination'),
                clickable: true
            }
        });
    }


    /**
     * Прилепляем слайдер при скролле
     */
    pinSlider() {
        if (App.mobile || !this.sliderContainer || window.innerHeight < 700 || window.innerWidth < 1000 || this.getDuration() <= 100) return;

        this.createScene();
        this.bindResize();
    }


    createScene() {
        this.scene = new ScrollMagic.Scene({
            triggerElement: document.querySelector('.content'),
            duration: this.getDuration(),
            triggerHook: 0,
            offset: 100
        })
            .setPin(this.imgContainer)
            .addTo(this.smController);
    }


    /**
     * Получаем точку, в которой слайдер должен отлипнуть
     */
    getDuration() {
        return this.productInner.clientHeight - this.imgContainer.clientHeight;
    }


    /**
     * Обновляем размеры сцены при ресайзе
     */
    bindResize() {
        App.W.on('resized', () => {
            this.updateState();
        });
    }

    updateState() {
        const duration = this.getDuration();

        if (window.innerWidth > 999 && window.innerHeight > 699 && duration > 100) {
            if (this.scene) {
                // Если сцена есть, обновляем её
                this.scene.duration(duration);
                this.scene.refresh();
            } else {
                // Если сцены нет, создаём
                this.createScene();
            }
        } else {
            // Для вертикальных планшетов и менее уничтожаем сцену
            try {
                this.scene = this.scene.destroy(true);
            } catch (error) {
                console.log(error);
            }
        }
    }


    pinBar() {
        new ScrollMagic.Scene({
            triggerElement: document.querySelector('.js-product-header'),
            triggerHook: 0,
            offset: 0,
            duration: 0
        })
            .addTo(this.smController)
            .on('enter', () => {
                document.querySelector('.js-product-bar').classList.add('_is-visible');
                document.getElementsByTagName('html')[0].classList.add('_is-open-pbar');
            })
            .on('leave', () => {
                document.querySelector('.js-product-bar').classList.remove('_is-visible');
                document.getElementsByTagName('html')[0].classList.add('_is-open-pbar');
            });
    }
}

if (document.querySelector('html.page-product')) {
    new PageProduct();
}



// WEBPACK FOOTER //
// ./_src/js/PageProduct.js